import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import { getOrderParameters, Orders } from '@europrocurement/l2d-domain/utils/orders';
import {
    ConfigurationParameters as OffreConfigurationParameters,
    Configuration,
    FormaliteApi,
    FormaliteFormaliteRead,
} from '../../../openApi/ApiOffre';
import { OFFRE_REDUCER_NAME, OFFER_FORMALITES_SLICE_NAME } from '../constants';

export type FormaliteApiObject = FormaliteFormaliteRead & Record<string, unknown>;

export type Formalites = FormaliteApiObject;

const mapperFormalites = function (formalites: FormaliteApiObject) {
    return {
        ...formalites,
    } as Formalites;
};

export function createFormalitesSlice(configuration: OffreConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new FormaliteApi(conf);

    const fetchFormalitesCollection: FetchCollectionData<FormaliteApiObject> = ({
        pagination: { page, itemsPerPage },
        xIdSociete,
        filters,
        orders,
    }) => {
        /** Get collection default orders */
        const defaultOrders: Orders = {
            libelle: 'asc',
        };

        const orderParameters = getOrderParameters(orders, defaultOrders);

        const requestParameters = {
            xIdSociete,
            page: page + 1,
            itemsPerPage,
            ...filters,
            domaineSocietesSocieteId: xIdSociete,
            ...orderParameters,
        };

        return api
            .apiFormalitesGetCollection(requestParameters)
            .then((res) => res.data)
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<FormaliteApiObject>>;
    };

    const fetchFormalitesItem: FetchItemDataType<FormaliteApiObject> = ({
        idItem,
        // pagination,
        xIdSociete,
    }) =>
        api
            .apiFormaliteIdGet({ id: String(idItem), xIdSociete })
            .then((res) => res.data) as Promise<FormaliteApiObject>;

    const { slice: formalitesSlice, dataSourcesThunks: formalitesDataSourcesThunks } =
        SliceFactory.createSlice<FormaliteApiObject, Formalites>(
            OFFER_FORMALITES_SLICE_NAME,
            OFFRE_REDUCER_NAME,
            [],
            fetchFormalitesCollection,
            fetchFormalitesItem,
            mapperFormalites,
        );

    return { formalitesSlice, formalitesDataSourcesThunks };
}
